import { Component } from 'react';
import type { ReactNode } from 'react';

interface PanelErrorBoundaryProps {
  readonly children: ReactNode;
  readonly onReset: () => void;
}

interface PanelErrorBoundaryState {
  hasError: boolean;
}

export class PanelErrorBoundary extends Component<PanelErrorBoundaryProps, PanelErrorBoundaryState> {
  state: PanelErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): PanelErrorBoundaryState {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
          onClick={() => {
            this.setState({ hasError: false });
            this.props.onReset();
          }}
        >
          <div className="rounded-lg bg-card p-6 text-center">
            <p className="text-muted-foreground">Could not load details.</p>
            <p className="mt-2 text-sm text-muted-foreground">Click to dismiss</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
